<template>
  <div class="preloader" :class="[`bg-${color}`]">
    <img class="preloader__icon h-24 w-24" src="@/assets/images/brand/logo.svg" />
    <p class="loading">{{ $t('dashboard.loading') }}</p>
  </div>
</template>

<script>
export default {
  name: 'Preloader',

  props: {
    color: {
      type: String,
      default: 'blue-light-main',
    },
  },
};
</script>

<style lang="scss" scoped>
.preloader {
  @apply fixed z-50 flex flex-col justify-center items-center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &__icon {
    animation: pulse 1.8s linear infinite both;
  }
  .loading {
    @apply text-xl mt-3;
    &::after {
      content: ".";
      animation: loading 1.2s ease alternate infinite;
    }
  }
}

@keyframes loading {
  60% {
    text-shadow: 0.3em 0 0 #000;
  }
  100% {
    text-shadow: 0.3em 0 0 #000, 0.6em 0 0 #000;
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.4);
  }
  50% {
    transform: scale(0.6);
  }
  100% {
    transform: scale(0.4);
  }
}
</style>
